import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import PostCard from "@/components/PostCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicProfile() {
  const { username } = useParams();

  const [user, setUser] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProfile() {
      try {
        const res = await axios.get(
          `${API}/public/profile/${username}`
        );

        setUser(res.data.user);
        setPosts(res.data.posts || []);
      } catch {
        setError("User not found");
      } finally {
        setLoading(false);
      }
    }

    fetchProfile();
  }, [username]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-cyan-50">
        <Navbar />
        <div className="pt-24 text-center text-gray-500">
          Loading profile…
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-cyan-50">
        <Navbar />
        <div className="pt-24 text-center text-red-500">
          User not found
        </div>
      </div>
    );
  }

  // calculations
  const totalPosts = posts.length;
  const totalInteractions = posts.reduce(
    (sum, post) => sum + (post.vote_count || 0),
    0
  );

  const isPremium = user.is_premium;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-cyan-50">
      <Navbar />

      <div className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
            
            {/* LEFT PROFILE CARD */}
            <div
              className={`self-start rounded-2xl p-6 shadow-lg border ${
                isPremium
                  ? "bg-gradient-to-br from-purple-500 via-pink-500 to-blue-500 text-white"
                  : "bg-white border-gray-200"
              }`}
            >
              <div className="flex flex-col items-center text-center">
                <div
                  className={`w-24 h-24 rounded-full overflow-hidden mb-4 ${
                    isPremium ? "ring-4 ring-yellow-300 animate-pulse" : ""
                  }`}
                >
                  <img
                    src={user.avatar_url}
                    alt={user.username}
                    className="w-full h-full object-cover"
                  />
                </div>

                <h2 className="text-xl font-semibold">
                  {user.username}
                </h2>

                {isPremium && (
                  <span className="mt-1 text-sm font-medium">
                    ⭐ Premium Member
                  </span>
                )}

                <div className="mt-6 space-y-2 text-sm">
                  <div>
                    <strong>{totalPosts}</strong> Posts
                  </div>
                  <div>
                    <strong>{totalInteractions}</strong> Interactions
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT POSTS */}
            <div className="md:col-span-2 space-y-6">
              {posts.length > 0 ? (
                posts.map((post) => (
                  <PostCard
                    key={post.id}
                    post={post}
                    isPublic={true}
                    hideSkip={true}
                  />
                ))
              ) : (
                <div className="text-center text-gray-500 py-10">
                  No posts yet
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}